
interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/8d13d909127b965a1b96285c4b9af1e2/8964f2db9296a8798ab5bb6895e36bf1.jpeg"
              alt="きらり保育園箕面園 ロゴ"
              className="h-12 w-auto object-contain"
            />
            <div className="hidden sm:block">
              <p className="text-sm font-bold text-gray-900 leading-tight">きらり保育園</p>
              <p className="text-xs text-teal-600 font-medium">箕面園 スポットワーク</p>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('philosophy')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-gray-800 hover:text-teal-600'
              }`}
            >
              私たちの理念
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-gray-800 hover:text-teal-600'
              }`}
            >
              特徴
            </button>
            <button
              onClick={() => scrollToSection('day-at-kirari')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-gray-800 hover:text-teal-600'
              }`}
            >
              一日の流れ
            </button>
            <button
              onClick={() => scrollToSection('information')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-gray-800 hover:text-teal-600'
              }`}
            >
              施設情報
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-teal-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
          </div>
          <button className="md:hidden text-gray-700 cursor-pointer">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-menu-line text-2xl"></i>
            </div>
          </button>
        </div>
      </div>
    </nav>
  );
}
